import { render, staticRenderFns } from "./TheAboutStep.vue?vue&type=template&id=7479b7ae&scoped=true"
import script from "./TheAboutStep.vue?vue&type=script&lang=js"
export * from "./TheAboutStep.vue?vue&type=script&lang=js"
import style0 from "./TheAboutStep.vue?vue&type=style&index=0&id=7479b7ae&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../../vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7479b7ae",
  null
  
)

export default component.exports